import { TableUI } from "components/design/TableUI";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { Badge, TaskType } from "components/Task/Badge";
import { FinancialView } from "./FinancialView";
import { FileObject } from "types/Models/fileObject";

export type BusinessFinancialClosing = {
  reporting_period: string;
  status: string;
  income_statement: {
    income_statement: FileObject | null;
    income_statement_document_type: string;
    income_statement_generate_link: string;
    income_statement_url: string | null;
  } | null;
  balance_sheet: {
    balance_sheet: FileObject | null;
    balance_sheet_document_type: string;
    balance_sheet_generate_link: string;
    balance_sheet_url: string | null;
  } | null;
};

const CLOSING_STATUS_TO_TASK_TYPE: Record<string, TaskType> = {
  COMPLETED: "COMPLETED",
};

type Props = {
  financialClosings: BusinessFinancialClosing[];
};

export const FinancialClosingsTable = ({ financialClosings }: Props) => {
  const createColumn = createColumnHelper<BusinessFinancialClosing>();

  const columns = [
    createColumn.accessor("reporting_period", {
      header: "REPORTING PERIOD",
      size: 22,
      cell: (info) => info.getValue(),
    }),
    createColumn.accessor("status", {
      header: "Status",
      size: 18,
      cell: (info) => {
        const status = info.getValue();
        const badgeType = CLOSING_STATUS_TO_TASK_TYPE[status];
        if (!badgeType) return status;
        return <Badge type={badgeType}>{status}</Badge>;
      },
    }),
    createColumn.accessor("income_statement", {
      header: "Income Statement",
      size: 30,
      cell: (info) => {
        if (!info.getValue()) return "-";
        return (
          <FinancialView
            item={{
              file_url: info.getValue()?.income_statement_generate_link,
              file_data: info.getValue()?.income_statement,
            }}
          />
        );
      },
    }),
    createColumn.accessor("balance_sheet", {
      header: "Balance Sheet",
      size: 30,
      cell: (info) => {
        if (!info.getValue()) return "-";
        return (
          <FinancialView
            item={{
              file_url: info.getValue()?.balance_sheet_generate_link,
              file_data: info.getValue()?.balance_sheet,
            }}
          />
        );
      },
    }),
  ];

  const table = useReactTable({
    columns,
    getCoreRowModel: getCoreRowModel(),
    data: financialClosings || [],
  });

  return <TableUI size="regular" table={table} />;
};
